import { Layout } from '@/components/Layout'
import { Menu } from '@/components/Menu'
import { MenusPageTabs } from '@/routes/MenusPageTabs'
import { PATHS } from '@/routes/PATHS'
import { type MenuProps } from 'antd'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import styles from './styles.module.scss'

export interface MenuItemProps {
  disabled?: boolean
  icon: React.ReactNode
  key: string
  label: React.ReactNode
  path?: string
  children?: {
    key: string
    label: React.ReactNode
    path: string
  }[]
  type?: string
}
interface SidebarProps extends MenuProps {
  menuItems: MenuItemProps[]
  width?: number | string
  collapsed: boolean
  setCollapsed: (value: boolean) => void
}

export function Sidebar({
  menuItems,
  width = 200,
  collapsed,
  setCollapsed,
  ...props
}: SidebarProps) {
  const { pathname } = useLocation()
  const [selectedKeys, setSelectedKeys] = useState<string[]>([])

  useEffect(() => {
    const isMenuItem =
      pathname === PATHS[MenusPageTabs.sectionsPage] ||
      pathname === PATHS[MenusPageTabs.itemsPage] ||
      pathname === PATHS[MenusPageTabs.modifiersPage] ||
      pathname === PATHS[MenusPageTabs.choicesPage]

    const isInsightsItem =
      pathname === PATHS.reviewAnalysis ||
      pathname === PATHS.sentimentAnalysis ||
      pathname === PATHS.keywordAnalysis

    if (isMenuItem) {
      setSelectedKeys([PATHS[MenusPageTabs.menusPage]])
    } else if (isInsightsItem) {
      setSelectedKeys([PATHS.reviewAnalysis])
    } else {
      setSelectedKeys([pathname])
    }
  }, [pathname, menuItems])

  return (
    <Layout.Sider
      className={styles.sidebarNavigationV2}
      theme="light"
      width={width}
      collapsible
      collapsedWidth={50}
      collapsed={collapsed}
      breakpoint="lg"
      onCollapse={(value) => setCollapsed(value)}
    >
      <Menu {...props} theme="light" mode="inline" selectedKeys={selectedKeys} items={menuItems} />
    </Layout.Sider>
  )
}
